import React from 'react';
import cn from 'classnames';
import * as Fi from 'react-icons/fi';
import { Select } from 'ui/components';

const options = [
  {
    value: 'opname',
    label: 'Opname',
  },
  {
    value: 'adjustment',
    label: 'Adjustment',
  },
];

const status = [
  {
    value: 'new',
    label: 'New',
  },
  {
    value: 'completed',
    label: 'Completed',
  },
];

const initialState = {
  type: null,
  document_status: null,
};

const Filter = ({ show, onClose, StockopnameTable, setCount }) => {
  const [{ type, document_status }, setState] = React.useState(initialState);

  const handleFilter = async (e) => {
    if (StockopnameTable?.State?.filter) {
      let x = [];
      Object.keys(StockopnameTable?.State?.filter).forEach((k) => {
        if (StockopnameTable?.State?.filter[k] && k !== 'warehouse_id') {
          x.push(k);
        }
      });
      setCount(x);
    }
  };

  const $onLoad = async () => {
    setState((prevState) => ({
      ...prevState,
      type:
        StockopnameTable?.State?.filter?.type === 'opname'
          ? options[0]
          : StockopnameTable?.State?.filter?.type === 'adjustment'
          ? options[1]
          : null,
      document_status:
        StockopnameTable?.State?.filter?.document_status === 'new'
          ? options[0]
          : StockopnameTable?.State?.filter?.document_status === 'completed'
          ? options[1]
          : null,
    }));
  };

  const handleType = (e) => {
    setState((prevState) => ({
      ...prevState,
      type: e,
    }));
    StockopnameTable?.filter('type', e?.value);
    handleFilter();
  };

  const handleStatus = (e) => {
    setState((prevState) => ({
      ...prevState,
      document_status: e,
    }));
    StockopnameTable?.filter('document_status', e?.value);
    handleFilter();
  };

  React.useEffect(() => {
    $onLoad();
  }, []);

  React.useEffect(() => {
    handleFilter();
  }, []);

  return (
    <>
      <div
        className={cn(
          show
            ? 'col-md-3 d-none d-md-block py-3 px-3 m-0 border-start'
            : 'd-none'
        )}
      >
        <div className="mb-3 border-bottom">
          <div className="d-flex align-items-center justify-content-between">
            <div className="page-pretitle fs-7 text-secondary">Filter</div>
            <div className="mt-n1">
              <button className="btn btn-action-close " onClick={onClose}>
                <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
              </button>
            </div>
          </div>
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">Tipe</div>
          <Select
            isClearable
            classNamePrefix={'select'}
            placeholder=""
            options={options}
            value={type}
            onChange={handleType}
          />
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">Status</div>
          <Select
            isClearable
            classNamePrefix={'select'}
            placeholder=""
            options={status}
            value={document_status}
            onChange={handleStatus}
          />
        </div>
      </div>

      <>
        <div
          className={cn('filter-overlay', show ? 'd-block d-md-none' : '')}
          onClick={onClose}
        />
        <div
          className={cn(
            'filter-modal d-block d-md-none py-3',
            show ? 'filter-show' : ''
          )}
        >
          <div className="mb-3 border-bottom">
            <div className="d-flex align-items-center justify-content-between">
              <div className="page-pretitle fs-7 text-secondary">Filter</div>
              <div className="mt-n1">
                <button className="btn btn-action-close " onClick={onClose}>
                  <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
                </button>
              </div>
            </div>
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">Tipe</div>
            <Select
              isClearable
              classNamePrefix={'select'}
              placeholder=""
              options={options}
              value={type}
              onChange={handleType}
            />
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">Status</div>
            <Select
              isClearable
              classNamePrefix={'select'}
              placeholder=""
              options={status}
              value={document_status}
              onChange={handleStatus}
            />
          </div>
        </div>
      </>
    </>
  );
};

export default Filter;
